var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('oeamtc-select',{attrs:{"value":_vm.valueIndex,"options":_vm.tagOptions,"disabled":_vm.disabled,"aria-name":"Kategorie","add-page-route-name":"tagsAdd","trip-id":_vm.callbackTripId},on:{"input":_vm.handleInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }